import Card      from './Card/Card';
import Countdown  from './Countdown/Countdown';
import Minimal    from './Minimal/Minimal';
import Spotlight  from './Spotlight/Spotlight';
import Board      from './Board/Board';

const templates = { Card, Countdown, Minimal, Spotlight, Board };

export default templates;
